import { FieldTypes } from 'drapcode-constant';
const { url } = FieldTypes;
export default async function (editor, opt = {}) {
  const traitManager = editor.TraitManager;
  let { collection, session, sessionTenant, sessionUserSettings, sessionSubTenant } =
    opt.bindCollectionOptions;
  if (!collection) {
    collection = opt.snippetCollectionTraitOptions
      ? opt.snippetCollectionTraitOptions.collection
      : null;
  }
  const traitOptions = collection
    ? collection.options
        .filter((field) => {
          return (
            field.type === url.id ||
            (field.type && field.metaData && JSON.parse(field.metaData).fieldType === url.id)
          );
        })
        .map((opt) => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
        .join(',')
    : [];

  const dataCollectionFieldName = collection ? `data-iframe-src-${collection.collectionId}` : '';
  const dataSessionFieldName = 'data-session';
  const dataSessionTenantFieldName = 'data-session-tenant';
  const dataSessionUserSettingsFieldName = 'data-session-user-settings';
  const dataSessionSubTenantFieldName = 'data-session-sub-tenant';
  const dataLocalStorageFieldName = 'data-local-storage';
  const dataSessionStorageFieldName = 'data-session-storage';
  const dataCookiesFieldName = 'data-cookies';

  let componentContent = '';
  const style = document.createElement('style');
  style.innerHTML = `
        .checkmark::after {
            left: 4px;
            top: 4px;
        }
        checkbox{
        all:unset;
        }
       
        select option:first-child {
            color: grey;
        }
        select.empty {
            color: grey;
        }
        select option[disabled]:first-child {
            display: none;
        }
        input[type=webconnect-text] {
            display:block;
        }
        input[type=webconnect-link] {
          display:block;
      }
        
  `;
  document.head.appendChild(style);
  if (collection || session || sessionTenant || sessionUserSettings || sessionSubTenant) {
    traitManager.addType(opt.traits.link.type, {
      createInput({ trait }) {
        componentContent = trait.attributes.content;
        const el = document.createElement('div');
        el.classList.add('custom-field');
        el.innerHTML = `    
              <div id="URL">
                ${
                  collection
                    ? `
                    <div class="form-group">
                          <label>
                              <input type="radio" name="getTextFrom"  value="collection"
                                    style="all: revert;"/>
                              Get Src From ${collection.collectionTitle}
                          </label>
                    </div>
                          `
                    : ''
                }
                ${
                  session
                    ? `
                    <div class="form-group">
                          <label>
                              <input type="radio" name="getTextFrom"  value="session" style="all: revert;"/>
                              Get Src From Logged In User
                          </label>
                      </div>
                          `
                    : ''
                }
                ${
                  sessionTenant
                    ? `
                    <div class="form-group">
                          <label>
                              <input type="radio" name="getTextFrom"  value="session-tenant" style="all: revert;"/>
                              Get Src From Logged In Tenant
                          </label>
                      </div>
                          `
                    : ''
                }
                ${
                  sessionUserSettings
                    ? `
                    <div class="form-group">
                          <label>
                              <input type="radio" name="getTextFrom"  value="session-user-setting" style="all: revert;"/>
                              Get Src From Logged In User Setting
                          </label>
                      </div>
                          `
                    : ''
                }
                ${
                  sessionSubTenant
                    ? `
                    <div class="form-group">
                          <label>
                              <input type="radio" name="getTextFrom"  value="session-sub-tenant" style="all: revert;"/>
                              Get Src From Logged In Sub Tenant
                          </label>
                      </div>
                          `
                    : ''
                }
                <div class="form-group">
                  <label>
                      <input type="radio" name="getTextFrom"  value="browser-local-storage"
                            style="all: revert;"/>
                      Get Src From Browser Local Storage
                  </label>
                </div>
                 <div class="form-group">
                  <label>
                      <input type="radio" name="getTextFrom"  value="browser-session-storage"
                            style="all: revert;"/>
                      Get Src From Browser Session Storage
                  </label>
                </div>
                 <div class="form-group">
                  <label>
                      <input type="radio" name="getTextFrom"  value="browser-session-cookies"
                            style="all: revert;"/>
                      Get Src From Browser Cookies
                  </label>
                </div>
            
                <div class="form-group">
                    <div id="select-field-div" style="display: none">
                        <select class="selectField form-control form-control-sm options-light">
        
                        </select>
                    </div>
                    <div id="json-field-div" class="col-md" style="display: none">
                      <input class="jsonField form-control form-control-sm" placeholder="Enter key e.g user.uuid">
                    </div>
                </div>
            </div> 
            </div>
            `;
        const radioButtons = el.querySelectorAll('input[type=radio][name="getTextFrom"]');
        const selectFieldDiv = el.querySelector('#select-field-div');
        const selectField = el.querySelector('.selectField');
        const jsonFieldDiv = el.querySelector('#json-field-div');
        const jsonField = el.querySelector('.jsonField');
        let selectedRadioButtonValue = null;
        const optionSources = {
          session: session.options,
          'session-tenant': sessionTenant.options,
          'session-user-setting': sessionUserSettings.options,
          'session-sub-tenant': sessionSubTenant.options,
        };
        radioButtons.forEach((radioButton) => {
          radioButton.addEventListener('click', () => {
            selectedRadioButtonValue = radioButton.value;
            selectField.innerHTML = '';
            jsonField.value = '';
            if (
              [
                'browser-local-storage',
                'browser-session-storage',
                'browser-session-cookies',
              ].includes(radioButton.value)
            ) {
              jsonFieldDiv.style.display = 'block';
              selectFieldDiv.style.display = 'none';
              return;
            }
            jsonFieldDiv.style.display = 'none';
            selectFieldDiv.style.display = 'block';
            let optionHtml = `<option value="">None</option>`;
            if (radioButton.value === 'collection') {
              optionHtml += traitOptions;
            } else if (optionSources[radioButton.value]) {
              optionHtml += optionSources[radioButton.value]
                .map((opt) => `<option value="${opt.id}" type="${opt.type}">${opt.name}</option>`)
                .join('');
            }
            selectField.innerHTML = optionHtml;
          });
        });
        return el;
      },
      onEvent({ elInput, component }) {
        const select = elInput.querySelector('.selectField');
        const jsonField = elInput.querySelector('.jsonField');
        const radioButton = document.querySelector('input[name="getTextFrom"]:checked').value;
        let selectFieldValue = select.value;
        const jsonFieldValue = jsonField.value;
        const selectedOption = select.options[select.selectedIndex];
        const fieldType = selectedOption && selectedOption.getAttribute('type');
        if (selectFieldValue.includes("'")) {
          selectFieldValue = selectFieldValue.replaceAll("'", '"');
        }
        const attr = component.getAttributes();
        const fieldMap = {
          session: dataSessionFieldName,
          'session-tenant': dataSessionTenantFieldName,
          'session-user-setting': dataSessionUserSettingsFieldName,
          'session-sub-tenant': dataSessionSubTenantFieldName,
          collection: dataCollectionFieldName,
          'browser-local-storage': dataLocalStorageFieldName,
          'browser-session-storage': dataSessionStorageFieldName,
          'browser-session-cookies': dataCookiesFieldName,
        };
        const jsonFieldSources = [
          'browser-local-storage',
          'browser-session-storage',
          'browser-session-cookies',
        ];
        const clearAllFields = () => {
          Object.values(fieldMap).forEach((field) => delete attr[field]);
          delete attr['data-field-type'];
        };
        clearAllFields();
        if (jsonFieldSources.includes(radioButton)) {
          if (jsonFieldValue) {
            attr[fieldMap[radioButton]] = jsonFieldValue;
          }
        } else if (fieldMap[radioButton] && selectFieldValue) {
          attr[fieldMap[radioButton]] = selectFieldValue;
          if (radioButton !== 'collection') {
            attr['data-field-type'] = fieldType;
          }
        }
        component.setAttributes(attr);
      },
      onUpdate({ elInput, component }) {
        const selectFieldDiv = elInput.querySelector('#select-field-div');
        const selectField = elInput.querySelector('.selectField');
        const jsonFieldDiv = elInput.querySelector('#json-field-div');
        const jsonField = elInput.querySelector('.jsonField');
        const attr = component.getAttributes();
        const collectionFieldValue = attr[dataCollectionFieldName] || '';
        const sessionConfigs = [
          {
            value: attr[dataSessionFieldName] || '',
            radio: 'session',
            options: session.options,
          },
          {
            value: attr[dataSessionTenantFieldName] || '',
            radio: 'session-tenant',
            options: sessionTenant.options,
          },
          {
            value: attr[dataSessionUserSettingsFieldName] || '',
            radio: 'session-user-setting',
            options: sessionUserSettings.options,
          },
          {
            value: attr[dataSessionSubTenantFieldName] || '',
            radio: 'session-sub-tenant',
            options: sessionSubTenant.options,
          },
        ];
        const browserConfigs = [
          {
            value: attr[dataLocalStorageFieldName] || '',
            radio: 'browser-local-storage',
          },
          {
            value: attr[dataSessionStorageFieldName] || '',
            radio: 'browser-session-storage',
          },
          {
            value: attr[dataCookiesFieldName] || '',
            radio: 'browser-session-cookies',
          },
        ];
        const showSelectField = (options, selectedValue) => {
          selectField.innerHTML = `
      <option value="">- Select One -</option>
      ${options.map((opt) => `<option value="${opt.id}">${opt.name}</option>`).join('')}
    `;
          selectField.value = selectedValue;
          selectFieldDiv.style.display = 'block';
          jsonFieldDiv.style.display = 'none';
        };
        const showJsonField = (value, radio) => {
          const radioButton = elInput.querySelector(`input[value="${radio}"]`);
          if (radioButton) {
            radioButton.checked = true;
          }
          jsonField.value = value;
          jsonFieldDiv.style.display = 'block';
          selectFieldDiv.style.display = 'none';
        };
        const matchedSession = sessionConfigs.find((config) => config.value);
        if (matchedSession) {
          const radioButton = elInput.querySelector(`input[value="${matchedSession.radio}"]`);
          if (radioButton) {
            radioButton.checked = true;
          }
          showSelectField(matchedSession.options, matchedSession.value);
          return;
        }
        if (collectionFieldValue) {
          const collectionRadioButton = elInput.querySelector('input[value="collection"]');
          if (collectionRadioButton) {
            collectionRadioButton.checked = true;
          }
          const normalizedValue = collectionFieldValue.includes('"')
            ? collectionFieldValue.replaceAll('"', "'")
            : collectionFieldValue;

          selectField.innerHTML = `
      <option value="">- Select One -</option>
      ${traitOptions}
    `;
          selectField.value = normalizedValue;
          selectFieldDiv.style.display = 'block';
          jsonFieldDiv.style.display = 'none';
          return;
        }
        const matchedBrowserField = browserConfigs.find((config) => config.value);
        if (matchedBrowserField) {
          showJsonField(matchedBrowserField.value, matchedBrowserField.radio);
        }
      },
    });
  } else {
    traitManager.addType(opt.traits.link.type, {
      createInput({ trait }) {
        const el = document.createElement('div');
        el.innerHTML = ``;
        return el;
      },
    });
  }
}
